module.exports = __webpack_public_path__ + "media/customizations/avemariamaster/logo-4d49cbf9a0c11aac54987719e97855d9.png";